import React, { Component } from "react";
import { connect } from "react-redux";

import { toggleStep } from "../../../../store/actions/multiplos-actions";
import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  SuccessContainer,
  SuccessIconContainer,
  SuccessIcon,
  SuccessTitle,
  SuccessText
} from "../styles";

class Success extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }
  render() {
    const { close, back } = this.props;
    return (
      <Container>
        <Header>
          <Left>
            {back ? (
              <BackButton
                title="Fechar"
                className="mdi mdi-arrow-left"
                onClick={() => this.props.dispatch(toggleStep(1))}
              />
            ) : null}
            <Title />
            <br />
            <br />
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <SuccessContainer>
          <SuccessIconContainer>
            <SuccessIcon className="mdi mdi-checkbox-marked-circle" />
          </SuccessIconContainer>
          <SuccessTitle>Novo contrato vinculado com sucesso!</SuccessTitle>
          <SuccessText>
            Agora você tem acesso as informações e solicitações do novo endereço
            vinculado.
          </SuccessText>
        </SuccessContainer>
      </Container>
    );
  }
}

export default connect()(Success);
